import React from "react";

/* ══ SMART HOME NOTIFICATION SETTINGS ═════════════════════
   User picks which HA events trigger local + in-app alerts.
   Prefs stored in smartHomeNotifPrefs config key.           */

const SH_NOTIF_EVENTS = [
  { key: "sh_door_opened",     label: "Door / window opened",   labelAr: "فتح باب / نافذة",     icon: "🚪" },
  { key: "sh_motion_detected", label: "Motion detected",        labelAr: "كشف حركة",           icon: "👁" },
  { key: "sh_lock_changed",    label: "Lock state changed",     labelAr: "تغيير حالة القفل",    icon: "🔒" },
  { key: "sh_alarm_triggered", label: "Alarm triggered",        labelAr: "تفعيل الإنذار",       icon: "🚨" },
  { key: "sh_alarm_armed",     label: "Alarm armed / disarmed", labelAr: "تسليح / تعطيل الإنذار", icon: "🛡" },
  { key: "sh_device_offline",  label: "Device went offline",    labelAr: "جهاز غير متصل",       icon: "📡" },
];

function SmartHomeNotifSettings({ prefs, onToggle, isRTL }) {
  return (
    <div className="sh-notif-settings">
      <h3 className="sh-section-title">{isRTL ? "إشعارات المنزل الذكي" : "Smart Home Notifications"}</h3>
      <p className="sh-notif-desc">
        {isRTL
          ? "اختر الأحداث التي تريد تلقي إشعارات عنها."
          : "Choose which events trigger notifications."}
      </p>
      <div className="sh-notif-list">
        {SH_NOTIF_EVENTS.map(evt => {
          const enabled = prefs[evt.key] !== false; /* default on */
          return (
            <div key={evt.key} className="sh-notif-item">
              <span className="sh-notif-icon">{evt.icon}</span>
              <span className="sh-notif-label">{isRTL ? evt.labelAr : evt.label}</span>
              <button
                className={`sh-toggle${enabled ? " sh-toggle-on" : ""}`}
                onClick={() => onToggle(evt.key, !enabled)}
              >
                <div className="sh-toggle-knob" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { SH_NOTIF_EVENTS };
export default SmartHomeNotifSettings;
